module.exports = __webpack_public_path__ + "ba2a941d553d7a08154bdd4ca5f2e46f.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/feed/components/images/avatar.png
 ** module id = 1253
 ** module chunks = 0
 **/